/*
 * @Author: WangQunQun
 * @Date: 2021-01-05 17:27:45
 * @LastEditTime: 2021-01-20 19:16:47
 * @LastEditors: WangQun
 * @Description: 该文件的作用是：工具类方法
 * @FilePath: /passport-platform/common/assets/js/utils.js
 */

/**
 * @name: 获取所有父节点
 * @description: 该函数的作用是：查找所有父节点的id
 * @param {*} tree 原树
 * @param {*} fn 回调
 * @param {*} config 自定义配置
 * @return {*} 所有父节点的ID（包含当前ID）
 * @author: WangQunQun
 */
export const findAllParent = (tree, fn, config = {}) => {
  const DEFAULT_CONFIG = {
    id: 'id',
    children: 'children'
  }

  config = Object.assign({}, DEFAULT_CONFIG, config)

  const path = []
  const list = [...tree]
  const visitedSet = new Set()
  const { children, id } = config

  while (list.length) {
    const node = list[0]
    if (visitedSet.has(node)) {
      path.pop()
      list.shift()
    } else {
      visitedSet.add(node)
      node[children] && list.unshift(...node[children])
      path.push(node)
      if (fn(node)) return path.map(item => item[id])
    }
  }
  return null
}

/**
 * @name: deepCopy
 * @description: 该函数的作用是：递归实现深拷贝
 * @param {*} list 源数据
 * @return {*} res 拷贝结果
 * @author: WangQun
 */
export const deepCopy = list => {
  if (typeof list !== 'object') return list
  let res
  if (Array.isArray(list)) {
    res = new Array(list.length)
    list.forEach((item, index) => (res[index] = deepCopy(item)))
  } else if (!Array.isArray(list)) {
    res = {} // 或者 new Map()
    Object.keys(list).forEach(key => (res[key] = deepCopy(list[key])))
  }
  return res
}

export const treeForeach = (tree, fn) => {
  tree.forEach(node => {
    fn(node)
    node.children && treeForeach(node.children, fn)
  })
}

// 设置当前项目域名，根据当前域名确定接口的域名，如果不在可信赖的域名范围内，则默认域名为test-udc.100tal.com
export const setCurDomain = () => {
  let getCurDomain = document.domain || ''
  const DOMAIN_LIST = [
    'passport.100tal.com',
    'test-passport.100tal.com',
    'passport.vdyoo.com',
    'test-passport.vdyoo.com'
  ]
  getCurDomain = DOMAIN_LIST.includes(getCurDomain) ? getCurDomain : 'test-passport.100tal.com'
  return getCurDomain
}

// 根据域名设置业务入口类型，营利&非营利
export const setEntity = () => {
  let getDomain = setCurDomain()
  let entity = ''
  switch (getDomain) {
    case 'test-passport.vdyoo.com':
      // 非营利主体域名为vdyoo，entity为2
      entity = 2
      break
    case 'passport.vdyoo.com':
      // 非营利主体域名为vdyoo，entity为2
      entity = 2
      break
    default:
      // 营利主体域名为100tal，entity为1
      entity = 1
  }
  return entity
}



// WEBPACK FOOTER //
// ./common/assets/js/utils.js